import Vue from 'vue';
import Vuex from 'vuex';
import $http from '@/utils/fetch';
import API from '@/config/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    formSetting: null
  },
  mutations: {
    SET_FORM_SETTING (state, payload) {
      state.formSetting = payload;
    }
  },
  actions: {
    fetchFormSetting ({ commit }, payload) {
      const data = {
        ...payload
      };
      return $http.post(API.GET_FORM_SETTING, data)
        .then(res => {
          commit('SET_FORM_SETTING', res.data);
        })
        .catch(err => {
          throw err;
        });
    }
  },
  modules: {
  }
});
